import { FILE_API_URL } from 'Constants/apis';
import { downloadFile } from 'Helpers/utils';
import useGetMemo from 'Hooks/teleconsult/useGetMemo';
import useAuth from 'Hooks/useAuth';
import PdfViewer from 'Modules/PdfViewer/PdfViewer';
import { removeModal } from 'Redux/modules/modal/actions';
import { shape, string } from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Grid, GridColumn, Modal } from 'semantic-ui-react';

import css from './Memorandom.less';

import PriceSummary from '@/components/PriceSummary';

const Memorandom = ({ data, id }) => {
  const {
    extraData: { id: memoId, memoFileId },
  } = data;
  const dispatch = useDispatch();
  const { token } = useAuth();

  const onDownload = () => {
    downloadFile(`${FILE_API_URL}/files/${memoFileId}`, token, 'Memo.pdf');
  };
  const onClose = () => {
    dispatch(removeModal(id));
  };
  const { memo, loading, getMemoDetails } = useGetMemo();

  useEffect(() => {
    getMemoDetails(memoId);
  }, [memoId, getMemoDetails]);

  const { subtotal, total, loyaltyAmount, currency } = memo ?? {};
  return (
    <div className={css.container}>
      <Modal
        onClose={onClose}
        open
        closeIcon
        className={css.customModal}
        style={{ width: 876 }}
        size="small">
        <Modal.Header>Memorandum</Modal.Header>
        <Modal.Content scrolling style={{ padding: 0 }}>
          <Grid celled="internally" padded columns={2}>
            <GridColumn width={4}>
              <h3 style={{ fontSize: 16, fontWeight: '600' }}>Fee</h3>
              <PriceSummary
                total={total}
                subTotal={subtotal}
                loyaltyAmount={loyaltyAmount}
                loading={loading}
                currency={currency}
              />
            </GridColumn>
            <GridColumn width={12}>
              <div style={{ width: 620, height: 880 }}>
                <PdfViewer fileID={memoFileId} />
              </div>
            </GridColumn>
          </Grid>
        </Modal.Content>
        <Modal.Actions style={{ textAlign: 'center' }}>
          <Button content="Download" primary onClick={onDownload} />
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default Memorandom;

Memorandom.propTypes = {
  data: shape({}).isRequired,
  id: string.isRequired,
};
